import { useParams, Link } from "react-router-dom";
import posts from "../data/posts";
import PageHeader from "../components/pageHeader";

const formatDate = (iso) => new Date(iso).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });

const InsightPost = () => {
  const { slug } = useParams();
  const post = posts.find((p) => p.slug === slug);

  if (!post) {
    return (
      <div className="max-w-2xl mx-auto px-5 py-24 text-center">
        <h1 className="text-3xl">Post not found</h1>
        <Link to="/solutions/deviceworks/insights" className="dw-link inline-block pt-4">← Back to Insights</Link>
      </div>
    );
  }

  return (
    <div>
      <PageHeader eyebrow={formatDate(post.date)} title={post.title} />
      <div className="max-w-2xl mx-auto px-5 py-16 flex flex-col gap-5">
        {post.body.map((para, i) => (
          <p key={i} className="dw-mini">{para}</p>
        ))}
        <Link to="/solutions/deviceworks/insights" className="dw-link pt-4">← Back to Insights</Link>
      </div>
    </div>
  );
};

export default InsightPost;
